import { Button, Container, Grid, Paper, Radio, Stack, Typography ,Box} from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { BASE_URL,toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components';

const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const GstReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { watch ,control } = methods;
  const user = JSON.parse(localStorage.getItem('user'));



   const handleExcelReportByProduct = async () => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const reportValue = watch('report');
    const fromDate = watch('from_date');
    const toDate = watch('to_date');

    const refId = encodeURIComponent(
      JSON.stringify({
        report: reportValue,
        from_date: fromDate,
        to_date: toDate
      })
    );

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/gst-report?refId=${refId}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      console.log(stockData,"STOCK DATA")

      if (stockData && stockData.length > 0) {
        const formattedStockData = [];

        stockData.forEach((entry, index) => {
          const grnDate = entry?.grn_date ? new Date(entry.grn_date).toLocaleDateString() : entry?.ret_date ? new Date(entry.ret_date).toLocaleDateString() :""
          const grnNo = entry?.grn_no || entry.ret_no || entry.inv_no;
          const invoiceNo = entry?.invoice_no || '';
          entry?.add_details?.forEach((item, i) => {
            const srNo = formattedStockData.length + 1;
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const mfgDate = item?.mfg_date ? new Date(item.mfg_date).toLocaleDateString() : '';
            formattedStockData.push({
              'Sr. No.': srNo,
              'Date': grnDate,
              'Bill No': grnNo,
              'Challan No': invoiceNo,
              'Product Name': item?.product_name || '',
              'HSN Code': item?.hsn_code || '',
              'Batch No': item?.batch_no || '',
              'Mfg Date': mfgDate,
              'Exp Date': expDate,
              'Quantity': item?.bill_qty ?? 0,
              'Rate': item?.rate ?? 0,
              'MRP': item?.mrp ?? 0,
              'Taxable Value': item?.taxable ?? 0,
              'CGST': item?.cgst ?? 0,
              'SGST': item?.sgst ?? 0,
              'IGST': item?.gst ?? 0,
              'Total With Tax': item?.total_with_tax ?? 0,
            });
          });
        });
        const fileName = `GST_REPORT_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedStockData);
        ws['!cols'] = [
          { wch: 6 },  // Sr. No.
          { wch: 12 }, // Date
          { wch: 15 }, // Bill No
          { wch: 15 }, // Challan No
          { wch: 25 }, // Product Name
          { wch: 15 }, // HSN Code
          { wch: 15 }, // Batch No
          { wch: 12 }, // Mfg Date
          { wch: 12 }, // Exp Date
          { wch: 10 }, // Quantity
          { wch: 10 }, // Rate
          { wch: 10 }, // MRP
          { wch: 15 }, // Taxable Value
          { wch: 10 }, // CGST
          { wch: 10 }, // SGST
          { wch: 10 }, // IGST
          { wch: 15 }  // Total With Tax
        ];
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
};




 const handleExcelReportGstSaleRegister = async () => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  try {
    const reportValue = watch('report');
    const fromDate = watch('from_date');
    const toDate = watch('to_date');

    const refId = encodeURIComponent(
      JSON.stringify({
        report: reportValue,
        from_date: fromDate,
        to_date: toDate
      })
    );

    const response = await axios.get(
      `${BASE_URL}/print/hospital/inventory/gst-report?refId=${refId}`
    );

    if (response.data.success) {
      const stockData = response?.data?.data;
      const results = stockData?.results || [];
      const indoorData = stockData?.indoorData || [];

      const formattedStockData = [];

      const processEntries = (entries) => {
        entries.forEach((entry) => {
          const grnDate = entry?.createdAt ? new Date(entry.createdAt).toLocaleDateString() : '';
          const grnNo = entry?.inv_no || entry?.grn_no || entry?.ret_no || '';
          const invoiceNo = entry?.invoice_no || '';

          entry?.add_details?.forEach((item) => {
            const srNo = formattedStockData.length + 1;
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const mfgDate = item?.mfg_date ? new Date(item.mfg_date).toLocaleDateString() : '';

            formattedStockData.push({
              'Sr. No.': srNo,
              'Date': grnDate,
              'Bill No': grnNo,
              'Challan No': invoiceNo,
              'Product Name': item?.product_name || '',
              'HSN Code': item?.hsn_code || '',
              'Batch No': item?.batch_no || '',
              'Mfg Date': mfgDate,
              'Exp Date': expDate,
              'Quantity': item?.bill_qty ?? 0,
              'Rate': item?.rate ?? 0,
              'MRP': item?.mrp ?? 0,
              'Taxable Value': item?.taxable ?? 0,
              'CGST': item?.cgst ?? 0,
              'SGST': item?.sgst ?? 0,
              'IGST': item?.gst ?? 0,
              'Total With Tax': item?.total_with_tax ?? 0,
            });
          });
        });
      };

      // Process both results and indoorData
      processEntries(results);
      processEntries(indoorData);

      if (formattedStockData.length > 0) {
        const fileName = `GST_REPORT_${new Date().toISOString().split('T')[0]}`;
        const ws = XLSX.utils.json_to_sheet(formattedStockData);
        ws['!cols'] = [
          { wch: 6 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 25 },
          { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 10 },
          { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 10 }, { wch: 10 },
          { wch: 10 }, { wch: 15 }
        ];
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast('No Stock Data Found', { variant: 'error' });
      }
    } else {
      toast('Something Went Wrong', { variant: 'error' });
    }
  } catch (error) {
    console.error('Excel Export Error:', error);
    toast('Failed to Export Excel', { variant: 'error' });
  }
};

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto',
          maxWidth: '100vw',
          minHeight: '100vh'
        }}
      >
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                GST Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  onClick={() => {
                    const report = watch('report');
                    const validReports = [
                      'gst_purchase_register',
                      'gst_purchase_return_register',
                      'gst_retail_sale_register',
                      'gst_retail_sale_return_register'
                    ];

                    if (validReports.includes(report)) {
                      handleExcelReportByProduct();
                    }else {
                      handleExcelReportGstSaleRegister();
                    }
                  }}
                  disabled={!watch('report')}
                >
                  Export Excel
                </CustomButtonn>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                {/* Date Inputs */}
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 1 }} name="from_date" type="date" />
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 1 }} name="to_date" type="date" />
                </Stack>

                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem', mb: 2, mt: 4 }}>Report Type</Typography>
                <Controller
                  name="report"
                  control={control}
                  render={({ field }) => (
                    <Stack direction="row" flexWrap="wrap" spacing={2} sx={{ rowGap: 2, columnGap: 2 }}>
                      {[
                        { value: 'gst_purchase_register', label: 'GST Purchase Register' },
                        { value: 'gst_purchase_return_register', label: 'GST Purchase Return Register' },
                        { value: 'gst_sale_register', label: 'GST Sale Register' },
                        { value: 'gst_retail_sale_register', label: 'GST Retail Sale Register' },
                        { value: 'gst_retail_sale_return_register', label: 'GST Retail Sale Return Register' }
                      ].map((option) => (
                        <Box
                          key={option.value}
                          sx={{
                            flex: '1 0 45%',
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            padding: '10px 14px',
                            backgroundColor: '#f9f9f9'
                          }}
                        >
                          <Radio
                            {...field}
                            value={option.value}
                            checked={field.value === option.value}
                            onChange={() => field.onChange(option.value)}
                            sx={{ mr: 1 }}
                          />
                          <Typography sx={{ fontWeight: 600, fontSize: '13px' }}>{option.label}</Typography>
                        </Box>
                      ))}
                    </Stack>
                  )}
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
